import { Trans as I18nTrans, useTranslation } from 'react-i18next';

import { changeLanguage as i18ChangeLanguage, TOptions } from 'i18next';

import { Language, LanguageVO } from '@zazume/zzm-utils';

import { I18NValues } from '#lib/i18n/generatedKeys';

export type TFunction = (key: I18NValues, options?: TOptions<any> | string) => string;

export interface UseI18NResponse {
  t: TFunction;
  changeLanguage: (lang: LanguageVO) => void;
  Trans: typeof I18nTrans;
  /**
   * @deprecated use languageVO instead
   */
  language: Language;
  languageVO: LanguageVO;
}

export const useI18n = (): UseI18NResponse => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang: LanguageVO) => i18ChangeLanguage(lang.toPlatform());

  return {
    t,
    changeLanguage,
    Trans: I18nTrans,
    language: i18n.language as Language,
    languageVO: LanguageVO.from(i18n.language)
  };
};
